import { Modal, TitleBar } from '@shopify/app-bridge-react';
import { Box, Button, Text } from '@shopify/polaris';
import { useBillingContext } from './BillingContext';
import { useInsufficientBalance } from './InsufficientBalanceContext';
import { AssetCreationName } from '@/types/media';

export const INSUFFICIENT_BALANCE_MODAL_ID = 'insufficient-balance-modal';

const InsufficientBalanceModal = ({ isLoading }: { isLoading: boolean }) => {
  const { isProPlan } = useBillingContext();
  const { handleUpgrade, creationName } = useInsufficientBalance();

  const isStudioVideo = creationName === AssetCreationName.studioVideo;
  const resourceType = isStudioVideo ? 'media' : 'asset';

  return (
    <Modal id={INSUFFICIENT_BALANCE_MODAL_ID} variant="base">
      <TitleBar title={isProPlan ? "You don't have enough credits! " : "You don't have enough credits! Upgrade to Pro"}>
        {!isProPlan && (
          <button variant="primary" onClick={handleUpgrade} disabled={isLoading}>
            {isStudioVideo ? 'Save draft and upgrade now' : 'Upgrade Now'}
          </button>
        )}
        <button onClick={() => shopify.modal.hide(INSUFFICIENT_BALANCE_MODAL_ID)}>Cancel</button>
      </TitleBar>
      <Box padding="400">
        <Text as="p" variant="bodyMd">
          You need more credits to generate this {resourceType}.{` `}
          {isProPlan
            ? 'Your balance will be refilled in the new billing period.'
            : 'Upgrade to Pro to get more credits and unlock additional features.'}
        </Text>
      </Box>
    </Modal>
  );
};

export default InsufficientBalanceModal;
